import type { MessageKey } from "@gioia365/i18n";
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, type AuthFailure } from "../api/auth";

type Translate = (key: MessageKey, params?: Record<string, string | number>) => string;

const messages: Record<AuthFailure, MessageKey> = {
  invalid_credentials: "auth.login.invalidCredentials",
  invalid_link: "auth.resetPassword.invalidLink",
  wrong_password: "account.password.wrong",
  password_too_short: "auth.resetPassword.tooShort",
  password_too_long: "auth.resetPassword.tooLong",
  session_expired: "errors.unauthenticated",
  rate_limited: "auth.errors.rateLimited",
  unavailable: "auth.errors.unavailable",
  unexpected: "auth.errors.unexpected",
};

/** Il testo da mostrare per un esito negativo, sempre dai cataloghi e mai con dati della richiesta. */
export function describeAuthFailure(t: Translate, failure: AuthFailure): string {
  return t(messages[failure], { min: PASSWORD_MIN_LENGTH, max: PASSWORD_MAX_LENGTH });
}
